// removed by extract-text-webpack-plugin
module.exports = {"item":"MetaList-module__item___1229H","active":"MetaList-module__active___YJvSm","controls":"MetaList-module__controls___2K3yQ","filter":"MetaList-module__filter___2eP3s","replace":"MetaList-module__replace___29XG3","search":"MetaList-module__search____-gsf","typeName":"MetaList-module__typeName___YmuMx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MetaList/MetaList.module.sass
// module id = 1069
// module chunks = 0